require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reviews-bern-h-2-o-brock.json") })
        }
      }, "path---reviews-bern-h-2-o-brock");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reviews-bern-h-2-o-brock!./.cache/json/reviews-bern-h-2-o-brock.json
// module id = 683
// module chunks = 231608221292675